import React from "react";
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Stack,
  Tooltip,
  Divider,
} from "@mui/material";
import { CommunicationIcon } from "./CommunicationIcon";

import ReceiptIcon from "@mui/icons-material/Receipt";
/* import ActivityPopupState from "../ActivityPopupState";
import UpdateCommunicationDialog from "../UpdateCommunicationDialog"; */
import { CustomerCommunication } from "../../../store/services/communicationService";
import ActivityPopupState from "./components/ActivityPopupState";
import UpdateCommunicationDialog from "./UpdateCommunicationDialog";

interface CommunicationRowProps {
  communication: CustomerCommunication;
  customerNo: number;
  isCompany?: boolean;
}

export const CommunicationRow = ({
  communication,
  customerNo,
  isCompany = false,
}: CommunicationRowProps) => {
  const [edit, setEdit] = React.useState(false);
  const renderTooltip = () => {
    if (isCompany) {
      return "Företagskontakt";
    }
    if (communication.IsPrimary) {
      return communication.SetByCustomer
        ? "Primär kontaktväg, registrerad av kund"
        : "Primär kontaktväg";
    }
    return "Sekundär kontaktväg";
  };

  return (
    <React.Fragment>
      <ListItem
        sx={{
          padding: 1,
          justifyContent: "space-between",
        }}
      >
        <ListItemIcon>
          <Tooltip title={renderTooltip()}>
            <>
              <CommunicationIcon
                type={communication.Type}
                isPrimary={communication.IsPrimary}
                isSetByCustomer={communication.SetByCustomer}
              />
            </>
          </Tooltip>

          {communication.Invoice && (
            <Tooltip title="Faktureras">
              <ReceiptIcon color="info" sx={{ fontSize: 22 }} />
            </Tooltip>
          )}
        </ListItemIcon>

        <ListItemText
          sx={{ margin: "1px" }}
          primary={
            <Stack>
              <Typography variant="caption" sx={{ fontSize: 14 }}>
                <ActivityPopupState
                  communication={communication}
                  setEditing={() => setEdit(true)}
                  customerNo={customerNo}
                  isCompany={isCompany}
                />
              </Typography>

              <Stack direction="row" spacing={1} alignItems="center">
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: 12,
                    fontWeight: 500,
                  }}
                >
                  {communication.Description}
                </Typography>
              </Stack>
            </Stack>
          }
        />
      </ListItem>
      <Divider component="li" />
      {edit && (
        <UpdateCommunicationDialog
          customerId={customerNo}
          type={communication.Type}
          onClose={() => setEdit(false)}
          editing={communication}
        />
      )}
    </React.Fragment>
  );
};

export default CommunicationRow;
